import { Prompt, Redirect } from "react-router-dom";

export default function SavePrompt({ blockIf, redirectIf, redirectTo }) {
    if (redirectIf) return <Redirect to={redirectTo} />;

    return <Prompt when={blockIf} message="Are you sure you want to leave without saving?" />;
}
